import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface MarianaTekLocationConfigurationValid {
    type: 'VALID';
    studioId: number;
}

export interface MarianaTekLocationConfigurationMissing {
    type: 'MISSING_STUDIO_ID';
}

export type MarianaTekLocationConfigurationUnion =
    | MarianaTekLocationConfigurationMissing
    | MarianaTekLocationConfigurationValid;

export class MarianaTekLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    MarianaTekLocationConfigurationUnion,
    'MARIANA_TEK_LOCATION'
>('MARIANA_TEK_LOCATION') { }
